import Valkyrie from "@sippy-platform/valkyrie";

import { Box, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

export default function LogIcon({ icon, title, color = "inherit" }) {
  return (
    <Tooltip title={title} placement="right">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Valkyrie icon={icon} style={{ color }} />
      </Box>
    </Tooltip>
  );
}

LogIcon.propTypes = {
  icon: PropTypes.object,
  title: PropTypes.string,
  color: PropTypes.string,
};
